import type {
  ConciseBranch,
  ExplicitBranchSpecification,
  PutBranchSpecification,
} from '@festina/configuration-general-types/configuration'
import { ConfigurationRepositoryBranchesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryBranchesService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { allConciseBranchesKeyPrefix } from '../keys/configuration'

type InputArguments = {
  server: ConfigurableServer
  newBranchName: string
  sourceBranch: ConciseBranch
}

export const useCopyBranch = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: async ({
      server,
      newBranchName,
      sourceBranch,
    }: InputArguments) => {
      const explicitBranchSpecification: ExplicitBranchSpecification = {
        _type: 'ExplicitBranchSpecification',
        sourceBranchName: sourceBranch.name,
        currentChangesetKey: sourceBranch.currentChangesetKey,
        baseChangesetKey: sourceBranch.baseChangesetKey,
        baseTypesVersionIds: sourceBranch.baseTypesVersionIds,
      }

      const requestBody: PutBranchSpecification = {
        _type: 'PutBranchSpecification',
        baseBranchName: sourceBranch.baseBranchName,
        followsBranchName: sourceBranch.followsBranchName,
        description: sourceBranch.description,
        branchCategory: sourceBranch.branchCategory,
        typesVersionIds: sourceBranch.typesVersionIds,
        explicitBranchSpecification,
      }

      await ConfigurationRepositoryBranchesService.branchServicePutPutBranch({
        componentName: server.toLocaleLowerCase(),
        branchName: newBranchName,
        requestBody,
      })
    },
    onSuccess: () =>
      client.invalidateQueries({ queryKey: [allConciseBranchesKeyPrefix] }),
  })
}
